import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { DigitalAsset } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { memo, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import { SelectedAssets } from './Downloadables'

const useStyles = makeStyles()((theme) => ({
  dropdownIcon: {
    marginLeft: '-10px',
    cursor: 'pointer',
  },
}))

type SelectAllProps = {
  digitalAssets: DigitalAsset[]
  selected: SelectedAssets
  showText?: boolean
  onChange: (assets: SelectedAssets) => void
}

const SelectAll: React.FC<React.PropsWithChildren<SelectAllProps>> = ({
  digitalAssets,
  selected,
  showText,
  onChange,
}) => {
  const { classes } = useStyles()
  const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null)

  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const selectedLength = Object.keys(selected).length

  const noneSelected = selectedLength === 0

  const allSelected = digitalAssets.length === selectedLength
  const someSelected = !allSelected && selectedLength > 0

  return (
    <Box display="flex" alignItems="center" mr={4}>
      {showText && <Typography>{I18n.t('downloadables.selectAll')}</Typography>}
      <Checkbox
        checked={allSelected}
        indeterminate={someSelected}
        onChange={() => onChange(noneSelected ? selectAll(digitalAssets) : {})}
        data-testid={'selectAllCheckbox'}
      />
      <ArrowDropDownIcon
        onClick={handleClick}
        color="action"
        className={classes.dropdownIcon}
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            onChange(selectAll(digitalAssets))
            handleClose()
          }}
        >
          {I18n.t('downloadables.all')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            onChange({})
            handleClose()
          }}
        >
          {I18n.t('downloadables.none')}
        </MenuItem>
      </Menu>
    </Box>
  )
}

const selectAll = (digitalAssets: DigitalAsset[]) => {
  return digitalAssets.reduce<SelectedAssets>((a, b) => {
    a[b.id] = b
    return a
  }, {})
}

export default memo(SelectAll)
